<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>订单管理</Breadcrumb-item>
        <Breadcrumb-item>业绩统计</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" lable-position="left">
        <Row :gutter="32">
          <i-col :span="6">
            <Form-item label="学生ID：" prop="uid">
              <Input name="stuId" v-model="queryParam.uid" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="注册渠道：">
              <channel-select v-model="queryParam.regType" @on-change="search"></channel-select>
              <!-- <Select v-model="queryParam.regType" filterable clearable @on-change="search">
                <Option v-for="item in $constant.studentCanal" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select> -->
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="签约渠道：">
              <Select v-model="queryParam.channel" filterable clearable @on-change="search">
                <Option v-for="item in $constant.orderChannel" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="课程顾问：" prop="adviserName">
              <Input name="adviserName" v-model="queryParam.adviserName" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="推荐人ID：" prop="recommendId">
              <Input name="recommendId" v-model="queryParam.recommendId" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="推荐人学导：" prop="recommendName">
              <Input name="recommendName" v-model="queryParam.recommendName" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="付款方式：">
              <Select v-model="queryParam.payWay" filterable clearable @on-change="search">
                <Option v-for="item in $constant.payWay2" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="是否到账：">
              <Select v-model="queryParam.isReceive" filterable clearable @on-change="search">
                <Option v-for="item in $constant.isReceive" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="代理订单：">
              <Select v-model="queryParam.agentOrder" filterable clearable @on-change="search">
                <Option v-for="item in $constant.yesNoNum" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="签单人：">
              <Input name="adminName" v-model="queryParam.adminName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="部门：">
              <Select v-model="queryParam.depmId" filterable clearable @on-change="search">
                <Option v-for="item in $constant.department" :value="item.code" :key="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="团队：">
              <Select v-model.number="queryParam.teamType" filterable clearable @on-change="search">
                <Option v-for="item in $constant.adviserGroup" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="学导：">
              <Input name="studyAdviser" v-model="queryParam.studyAdviser" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="订单ID：">
              <Input name="orderId" v-model="queryParam.orderId" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item :label-width="100" label="第三方付款码：">
              <Input name="orderCode" v-model="queryParam.orderCode" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="到账方式：">
              <Select v-model="queryParam.receiveType" filterable clearable @on-change="search">
                <Option v-for="item in $constant.payWay2" :value="item.code" :key="item.code">
                  {{item.text}}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="注册时间：">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                           @on-change="regStartTimeChange" v-model="regStartTime" style="width: 100%;">
                  </Date-picker>
                </Col>
                <Col :span="1" style="text-align: center;"><span>-</span></Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间"
                            @on-change="regEndTimeChange" v-model="regEndTime" style="width: 100%;">
                  </Date-picker>
                </Col>
              </Row>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="退款时间：">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                              @on-change="refundStartTimeChange" v-model="refundStartTime" style="width: 100%;">
                  </Date-picker>
                </Col>
                <Col :span="1" style="text-align: center;"><span>-</span></Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间"
                           @on-change="refundEndTimeChange" v-model="refundEndTime" style="width: 100%;">
                  </Date-picker>
                </Col>
              </Row>
            </Form-item>
          </i-col>
          <i-col :span="8">
          <Form-item label="付款时间：">

            <Row>
              <Col :span="11">
                <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                            @on-change="payStartTimeChange" :value="queryParam.payStartTimeDate" style="width: 100%;">
                </Date-picker>
              </Col>
              <Col :span="1" style="text-align: center;"><span>-</span></Col>
             <Col :span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间"
                         @on-change="payEndTimeChange" v-model="payEndTime" style="width: 100%;">
              </Date-picker>
            </Col>
          </Row>
          </Form-item>
        </i-col>
        <i-col :span="6">
            <Form-item label="教材版本">
              <Select v-model.number="queryParam.materialVersion" @on-change="search" placeholder="请选择" clearable>
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
              搜索
            </Button>
          </i-col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" @click="exportData" :loading="exportLoading" v-perm="'535'" >导出</Button>
    </div>
    <List :height="710" ref="dataList" :tableColumns="title" :reload="reload"
    listUrl="/performance/list" :params="queryParam" :onLoading="onLoading" :onSelection="onSelection" operator="">
    </List>
    <performance-model ref="tmodal" :value="showEditPerfModel" :isEditisReceive="isEditisReceive" :pData="pData" @on-close="showEditPerfModel=false" :successCallback="search" :formData="formData"></performance-model>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
  </div>
</template>

<script>
    import PerformanceModel from './PerformanceModel.vue'
    import ShowImageCarousel from './ShowImageCarousel.vue'
import Row from 'iview/src/components/grid/row';
import { fetchTchScoreMap, renderTchNameWithScore } from '@/utils/tchScore'
    export default {
      components: {PerformanceModel, ShowImageCarousel},
      data () {
        let $constant = this.$constant
        let $moment = this.$moment
        let self = this
        return {
          top: 260,
          searchLoading: false,
          exportLoading: false,
          reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
          showImgModal: false,
          showImgList: [],
          queryParam: {
            uid: null,
            recommendId: null,
            recommendName: '',
            channel: null,
            payWay: null,
            isReceive: null,
            depmId: null,
            teamType: null,
            adminName: '',
            studyAdviser: '',
            adviserName: '',
            payStartTime: '',
            payStartTimeDate: '',
            payEndTime: null,
            regStartTime: null,
            regEndTime: null,
            refundStartTime: null,
            refundEndTime: null,
            orderId: '',
            orderCode: '',
            receiveType: null,
            regType: '',
            agentOrder: null,
            materialVersion: null
          },
          payEndTime: null,
          refundStartTime: null,
          refundEndTime: null,
          regStartTime: null,
          regEndTime: null,
          showEditPerfModel: false,
          formData: {
            id: null,
            receiveType: null,
            money: null,
            time: null,
            remark: '',
            invoiceTime: null,
            invoiceMoney: null,
            isRushRed: null,
            refundMoney: null,
            refundTime: null
          },
          isEditisReceive: false,
          pData: {
            time: null,
            invoiceTime: null,
            refundTime: null
          },
          rowId: null,
          title: [
            {
              title: '序号',
              width: 80,
              align: 'center',
              fixed: 'left',
              render: (h, params) => {
                return h('span', params.row._index + 1)
              }
            },
            {
              title: '订单id',
              width: 120,
              align: 'center',
              fixed: 'left',
              render: (h, params) => {
                let row = params.row
                let agentOrder = row.agentOrder
                if (agentOrder === 1) {
                  return h('span',
                    [
                      h('span', row.orderId),
                      h('span', {style: {color: 'red'}}, '(代)')
                    ]
                  )
                } else {
                  return h('span', row.orderId)
                }
              }
            },
            {
              title: '是否到账',
              width: 150,
              align: 'center',
              fixed: 'left',
              render: (h, params) => {
                let isReceive = params.row.isReceive
                let propsYes = {size: 'mini'}
                let propsNo = {size: 'mini'}
                if (isReceive === 1) {
                  propsYes = {type: 'primary', size: 'mini'}
                } else if (isReceive === 0) {
                  propsNo = {type: 'primary', size: 'mini'}
                }
                return h('el-row', [
                  h('el-button', {props: propsYes,
                    on: { click: () => {
                      params.row.isReceive = 1
                      self.editPerformance(params.row, true)
                    } }}, '是'),
                  h('el-button', {props: propsNo,
                    on: { click: () => {
                      params.row.isReceive = 0
                      self.editPerformance(params.row, true)
                    } }}, '否')
                ])
              }
            },
            {
              title: '签约渠道',
              width: 120,
              align: 'center',
              fixed: 'left',
              render: (h, params) => {
                let channel = params.row.channel
                let orderChannel = $constant.getEnum($constant.orderChannel, channel)
                return h('span', orderChannel && orderChannel.text)
              }
            },
            {
              title: '注册渠道',
              width: 120,
              align: 'center',
              fixed: 'left',
              key: 'regType'
              // render: (h, params) => {
              //   let regType = params.row.regType
              //   let regTypeEnum = $constant.getEnum($constant.regTypes, regType)
              //   return h('span', regTypeEnum && regTypeEnum.text)
              // }
            },
            {
              title: '学生ID/姓名',
              width: 150,
              align: 'center',
              fixed: 'left',
              render: (h, params) => {
                let uid = params.row.uid
                let stuName = params.row.stuName
                return h('span', uid + '-' + stuName)
              }
            },
            {
              title: '学习账号',
              width: 130,
              align: 'center',
              key: 'mobile',
              render: (h, params) => {
                return h('Poptip', {
                  props: {
                    trigger: 'hover'
                  }
                }, [
                  h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                    + "****" + params.row.mobile.substring(7) : params.row.mobile),
                  // 当前行展示的数据
                  h('div', {slot: 'content'}, params.row.mobile)
                ])
              }
            },
            {
              title: '绑定老师',
              width: 270,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                if (row.tchBoundNum && row.tchBoundNum > 0) {
                  let list = row.bookWorkLessonOpenedTimeList
              let spanArr = []
              const scoreMap = this.rankScoreMap || {}
              if (list) {
                list.forEach(function (element) {
                      let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                      spanArr.push(h('span', [
                        renderTchNameWithScore(h, { text: element.tchId + '-' + element.tchName + '-', score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }),
                        h('span', {style: {color: '#FF6103'}}, '外管' + '-' + element.tchAdviserNickname),
                        h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                      spanArr.push(h('br'))
                    })
                  }
                  let levelTitle = row.levelTitle
                  if (levelTitle) {
                    levelTitle = '当前等级：' + levelTitle
                  }
                  return h('div', {style: {'font-size': '12px'}}, [h('p', levelTitle), h('p', spanArr)])
                } else {
                  return h('div', '未绑定')
                }
              }
            },
            {
              title: '部门',
              width: 100,
              align: 'center',
              key: 'department'
            },
            {
              title: '团队',
              width: 100,
              align: 'center',
              render: (h, params) => {
                let teamType = params.row.teamType
                if (teamType) {
                  let team = $constant.getEnum($constant.adviserGroup, teamType)
                  return h('span', team && team.text)
                }
                return h('span', null)
              }
            },
            {
              title: '签单人',
              width: 100,
              align: 'center',
              render: (h, params) => {
                let adminName = params.row.adminName
                return h('span', adminName)
              }
            },
            {
              title: '学导',
              width: 100,
              align: 'center',
              key: 'studyAdviser'
            },
            {
              title: '课程顾问',
              width: 100,
              align: 'center',
              key: 'adviserName'
            },
            {
              title: '付款金额',
              width: 100,
              align: 'center',
              key: 'amount'
            },
            {
              title: '核算金额',
              width: 100,
              align: 'center',
              render: (h, params) => {
                let amount = params.row.amount
                let payWay = params.row.payWay
                if (payWay === 4) { // 库分期
                  return h('span', Number(amount * 0.94).toFixed(2))
                }
                return h('span', amount)
              }
            },
            {
              title: '外教课节',
              width: 95,
              align: 'center',
              key: 'num'
            },
            {
              title: '赠送课时',
              width: 95,
              align: 'center',
              key: 'discountNum'
            },
            {
              title: '付款时间',
              width: 110,
              align: 'center',
              render: (h, params) => {
                let time = params.row.payTime
                return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '第三方付款码',
              key: 'orderCode',
              width: 150,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                if (row.orderCode) {
                  return h('span', row.orderCode)
                } else if (row.url) {
                  return h('a', {on: {click: () => this.viewPic(row)}}, '查看凭证')
                }
                return h('span', '')
              }
            },
            {
              title: '到帐方式',
              width: 100,
              align: 'center',
              render: (h, params) => {
                let type = params.row.receiveType
                let receiveType = $constant.getEnum($constant.receiveType, type)
                return h('span', receiveType && receiveType.text)
              }
            },
            {
              title: '到帐金额',
              width: 120,
              align: 'center',
              key: 'money'
            },
            {
              title: '到账时间',
              width: 110,
              align: 'center',
              render: (h, params) => {
                let time = params.row.time
                return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '备注',
              width: 110,
              align: 'center',
              key: 'remark'
            },
            {
              title: '开票时间',
              width: 110,
              align: 'center',
              render: (h, params) => {
                let time = params.row.invoiceTime
                return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '开票金额',
              width: 120,
              align: 'center',
              key: 'invoiceMoney'
            },
            {
              title: '退票冲红',
              width: 120,
              align: 'center',
              render: (h, params) => {
                let val = params.row.isRushRed
                let isRushRed = $constant.getEnum($constant.yesNoNum, val)
                return h('span', isRushRed && isRushRed.text)
              }
            },
            {
              title: '退款金额',
              width: 120,
              align: 'center',
              key: 'refundMoney'
            },
            {
              title: '退款时间',
              width: 120,
              align: 'center',
              render: (h, params) => {
                let val = params.row.refundTime
                return h('span', val && $moment(val, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '操作',
              width: 100,
              align: 'center',
              fixed: 'right',
              render: (h, params) => {
                return h('el-row', [
                  h('el-button', {props: {size: 'mini', type: 'text'},
                    on: { click: () => {
                      self.editPerformance(params.row, false)
                    } }}, '编辑'),
                  // h('el-button', {props: {size: 'mini', type: 'text'},
                  //   on: { click: () => {
                  //     self.deletePerformance(params.row.id)
                  //   } }}, '删除')
                ])
              }
            },
            {
              title: '推荐人ID',
              width: 120,
              align: 'center',
              key: 'recommendId'
            },
            {
              title: '推荐人学导',
              width: 120,
              align: 'center',
              key: 'recommendName'
            },
            {
              title: '付款方式',
              width: 100,
              align: 'center',
              render: (h, params) => {
                let payWay = params.row.payWay
                if (payWay !== null) {
                  let p = $constant.getEnum($constant.payWay2, payWay)
                  return h('span', p && p.text)
                }
                return h('span', null)
              }
            }
          ],
        }
      },
      mounted: function () {
        let self = this
        let query = self.$route.query
        if (query.receiveType) {
          this.queryParam.receiveType = parseInt(query.receiveType)
        }
        if (query.payWay) {
          this.queryParam.payWay = parseInt(query.payWay)
        }
        if (query.isReceive) {
          this.queryParam.isReceive = parseInt(query.isReceive)
        }
        if (query.channel) {
          this.queryParam.channel = parseInt(query.channel)
        }
        if (query.regType) {
          this.queryParam.regType = query.regType
        }
        if (query.teamType) {
          this.queryParam.teamType = parseInt(query.teamType)
        }
        if (query.uid) {
          this.queryParam.uid = parseInt(query.uid)
        }
        if (query.recommendId) {
          this.queryParam.recommendId = parseInt(query.recommendId)
        }
        if (query.recommendName) {
          this.queryParam.recommendName = query.recommendName
        }
        if (query.depmId) {
          this.queryParam.depmId = parseInt(query.depmId)
        }
        if (query.adminName) {
          this.queryParam.adminName = query.adminName
        }
        if (query.studyAdviser) {
          this.queryParam.studyAdviser = query.studyAdviser
        }
        if (query.adviserName) {
          this.queryParam.adviserName = query.adviserName
        }
        if (query.orderId) {
          this.queryParam.orderId = query.orderId
        }
        if (query.orderCode) {
          this.queryParam.orderCode = query.orderCode
        }
        if (query.payStartTime) {
          this.queryParam.payStartTime = parseInt(query.payStartTime) * 1000
        }
        if (query.payEndTime) {
          this.payEndTime = parseInt(query.payEndTime) * 1000
        }
        if (query.regStartTime) {
          this.regStartTime = parseInt(query.regStartTime) * 1000
        }
        if (query.regEndTime) {
          this.regEndTime = parseInt(query.regEndTime) * 1000
        }
        if (query.refundStartTime) {
          this.refundStartTime = parseInt(query.refundStartTime) * 1000
        }
        if (query.refundEndTime) {
          this.refundEndTime = parseInt(query.refundEndTime) * 1000
        }
      },

      created: function () {

        let startTime = this.queryParam.payStartTime
        if (startTime !== '') {
          this.queryParam.payStartTimeDate = this.$moment.unix(startTime).toDate()
        }
        if (startTime === '') {
          let momentDate = this.$moment().add(-24, 'M')
          momentDate.millisecond(0)
          momentDate.second(0)
          momentDate.minute(0)
          momentDate.hour(0)
          this.queryParam.payStartTimeDate = momentDate.toDate()
          this.queryParam.payStartTime = momentDate.format('X')
        }
      },

      methods: {
        search () {

          if (this.payEndTime) {
            this.queryParam.payEndTime = this.payEndTime / 1000
          } else {
            this.queryParam.payEndTime = null
          }
          if (this.regStartTime) {
            this.queryParam.regStartTime = this.regStartTime / 1000
          } else {
            this.queryParam.regStartTime = null
          }
          if (this.regEndTime) {
            this.queryParam.regEndTime = this.regEndTime / 1000
          } else {
            this.queryParam.regEndTime = null
          }
          if (this.refundStartTime) {
            this.queryParam.refundStartTime = this.refundStartTime / 1000
          } else {
            this.queryParam.refundStartTime = null
          }
          if (this.refundEndTime) {
            this.queryParam.refundEndTime = this.refundEndTime / 1000
          } else {
            this.queryParam.refundEndTime = null
          }
          this.reload = new Date().getTime()
        },
                onLoading (loading) {
          this.searchLoading = loading
        
          if (!loading) {
            this.loadBoundTchMonthScores()
          }
        },
    loadBoundTchMonthScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        this.rankScoreMap = {}
        return
      }
      const ids = []
      table.forEach(function (row) {
        const list = row.bookWorkLessonOpenedTimeList || []
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId)
          }
        })
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        self.rankScoreMap = map || {}
      })
    },
        onSelection (selection) {
          this.selection = selection
        },
        payStartTimeChange (val) {
          this.queryParam.payStartTime = val && this.$moment(val, 'YYYY-M-D H:m').format('X')
        },
        payEndTimeChange (val) {
          if (val) {
            this.queryParam.payEndTime = val / 1000
          } else {
            this.queryParam.payEndTime = null
          }
        },
        regStartTimeChange (val) {
          if (val) {
            this.queryParam.regStartTime = val / 1000
          } else {
            this.queryParam.regStartTime = null
          }
        },
        regEndTimeChange (val) {
          if (val) {
            this.queryParam.regEndTime = val / 1000
          } else {
            this.queryParam.regEndTime = null
          }
        },
        refundStartTimeChange (val) {
          if (val) {
            this.queryParam.refundStartTime = val / 1000
          } else {
            this.queryParam.refundStartTime = null
          }
        },
        refundEndTimeChange (val) {
          if (val) {
            this.queryParam.refundEndTime = val / 1000
          } else {
            this.queryParam.refundEndTime = null
          }
        },
        viewPic (row) {
          this.showImgList = row.urls
          this.showImgModal = true
        },
        closeImgModal () {
          this.showImgList = []
          this.showImgModal = false
        },
        exportData () {
          this.exportLoading = true
          let params = {}
          this.$helper.mergeProperties(this.queryParam, params)
          this.$http.get('/performance/export', {responseType: 'arraybuffer', params: params}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '业绩统计.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
            this.$Message.error('无权限')
          })
        },
        editPerformance (row, isEditisReceive) {
          if (row.isReceive === 1 && isEditisReceive) {
            let self = this
            this.$http.post('/performance/update', {id: row.id, isReceive: row.isReceive}).then(function (res) {
              if (res && res.data > 0) {
                self.search()
              }
            })
          } else {
            this.top = parseInt((row._index + 1) * 64 + 200)
            if (this.top < 530) {
              this.$refs.tmodal.$el.lastChild.style.paddingTop = this.top + 'px'
            } else {
              this.$refs.tmodal.$el.lastChild.style.paddingTop = this.top - 380 - window.scrollY + 'px'
            }
            this.showEditPerfModel = true
            this.isEditisReceive = isEditisReceive
            this.formData.id = row.id
            this.formData.isReceive = row.isReceive
            this.formData.receiveType = row.receiveType || null
            this.formData.money = row.money || null
            this.formData.time = row.time || null
            if (row.time) {
              this.pData.time = row.time * 1000
            }
            this.formData.remark = row.remark || null
            this.formData.invoiceMoney = row.invoiceMoney || null
            this.formData.invoiceTime = row.invoiceTime || null
            if (row.invoiceTime) {
              this.pData.invoiceTime = row.invoiceTime * 1000
            }
            this.formData.isRushRed = row.isRushRed
            this.formData.refundMoney = row.refundMoney || null
            this.formData.refundTime = row.refundTime || null
            if (row.refundTime) {
              this.pData.refundTime = row.refundTime * 1000
            }
          }
        },
        /*
        deletePerformance (id) {
          let self = this
          if (id) {
            self.$http.post('/performance/deletePerformance', {id: id}).then((res) => {
              if (res && res.data > 0) {
                self.search()
              }
            })
          }
        }
        */
      }
    }
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// PerformanceList.vue?1146c5eb